// services/PrecioPlanServicioHistoryService.ts
import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const HISTORY_API_URL = 'precio-plan-servicio-history/';

export const fetchPrecioPlanServicioHistory = async () => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(HISTORY_API_URL);
        return response.data;
    });
};